import { Meta } from "../partials/meta";

export default function Error() {
    return (
        <>
            <Meta title="Oops" description="Page not found"/>
            <h1>Sorry, this page cannot be found...</h1>
        </>
    );
}